import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import { SystemUserForm, mountForm, unmountForm } from '@kineticdata/react';
import { generateFormButtons, FormError } from '@kineticdata/ui';
import { regRoute, regSaga } from '../../store';
import { ChangePasswordField } from '../common/forms/ChangePasswordField';

const formKey = 'system-setup-user';

regRoute('SYSTEM_USER_PAGE', '/system/setup/user');

regSaga(
  takeEvery('ENTER_SYSTEM_USER_PAGE', function* () {
    yield call(mountForm, formKey);
  }),
);
regSaga(
  takeEvery('LEAVE_SYSTEM_USER_PAGE', function* () {
    yield call(unmountForm, formKey);
  }),
);

export const SystemSetupUser = () => (
  <div className="content-container">
    <SystemUserForm
      formKey={formKey}
      alterFields={{
        changePassword: {
          component: ChangePasswordField,
        },
      }}
      components={{
        FormError,
        FormButtons: generateFormButtons({
          submitLabel: 'Update System User',
          cancelPath: '/system/setup/config',
        }),
      }}
    >
      {({ form }) => form}
    </SystemUserForm>
  </div>
);
